(function (){
    'use strict';

    angular
        .module('surveys', [
            'ui.router',
            'ui.bootstrap',
            'ngDialog',
            'ui.select',
            'ngSanitize'
        ]);
})();